export const Story = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative py-24 lg:py-32 bg-[#EAE3D9]/60 kraft-grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-[#B33922]/10 rotate-[-3deg]" />
            <img
              src="https://images.unsplash.com/photo-1723155182094-af2f63472d0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzcGljZXMlMjB0ZXh0dXJlfGVufDB8fHx8MTc3NjUyMzYzNXww&ixlib=rb-4.1.0&q=85"
              alt="Fresh red chillies on a rustic surface"
              className="relative rounded-2xl w-full aspect-[4/5] object-cover shadow-2xl"
            />
            <div className="absolute -top-4 -left-4 w-24 h-24 rounded-full bg-[#D99026]/80 backdrop-blur-sm flex items-center justify-center text-mo-cream shadow-xl rotate-[-8deg]">
              <div className="text-center">
                <div className="font-serif-display italic text-2xl leading-none">est.</div>
                <div className="font-serif-display text-xl leading-none mt-0.5">2023</div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-mo-cream border border-[#5C5248]/15 rounded-xl shadow-xl p-5 max-w-[220px] hidden sm:block">
              <div className="font-serif-display text-lg italic text-mo-terracotta">"Maati"</div>
              <div className="text-xs text-mo-ink-soft mt-1">
                Hindi for <em>earth</em> — the soil, the hands, the home.
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="text-xs uppercase tracking-[0.3em] text-mo-terracotta mb-4">
            — Our Story
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-mo-ink leading-[1.05]">
            Built quietly, <br />
            <span className="italic text-mo-green">one batch at a time.</span>
          </h2>

          <div className="mt-8 space-y-5 text-mo-ink-soft text-base sm:text-lg leading-relaxed max-w-xl">
            <p>
              Maati Organics began in a farmhouse kitchen, when we noticed the
              spices we bought off a shelf never smelled like the ones our
              grandmothers stored in steel <em>dabbas</em>.
            </p>
            <p>
              So we went back. Back to the farmers we grew up around. Back to
              sun-drying on rooftops. Back to the slow, unhurried grind of
              handwork and patience. We measured, we tasted, we started again —
              until a single pinch could transport you home.
            </p>
            <p className="font-serif-display italic text-mo-ink text-xl">
              "If we can't eat it ourselves, we don't sell it." — that's our only rule.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            <Pill label="Farmer-sourced" />
            <Pill label="Hand-pounded" />
            <Pill label="Kraft-sealed" />
          </div>
        </div>
      </div>
    </section>
  );
};

const Pill = ({ label }) => (
  <div className="text-center px-3 py-3 rounded-full border border-[#5C5248]/25 text-xs uppercase tracking-[0.18em] text-mo-ink-soft bg-[#F9F6F0]/70">
    {label}
  </div>
);
